import { render } from "./DadosCompletosVisitaView.vue?vue&type=template&id=5b7cacad&scoped=true"
import script from "./DadosCompletosVisitaView.vue?vue&type=script&lang=js"
export * from "./DadosCompletosVisitaView.vue?vue&type=script&lang=js"

import "./DadosCompletosVisitaView.vue?vue&type=style&index=0&id=5b7cacad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7cacad"]])

export default __exports__